import { makeStyles } from '@mui/styles'
import { getPixelInREM } from '../../common/material'

export const useFilterBarStyles = makeStyles((theme) => ({
    container: {
        padding: getPixelInREM(20),
        marginBottom: getPixelInREM(20),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    popover: {
        minWidth: 400,
        zIndex: 20
    },
    popoverContentContainer: {
        padding: `${getPixelInREM(5)} 0 ${getPixelInREM(5)} 0`
    },
    addFilterEvidence: {
        textTransform: 'none'
    },
    option: {
        marginRight: 0,
        padding: `0 ${getPixelInREM(10)} 0 ${getPixelInREM(10)}`,
        [`&:hover`]: {
            backgroundColor: theme.palette.grey[100]
        }
    },
    selectFilterContainer: {
        display: 'flex',
        flexDirection: 'column'
    },
    chipContainer: {
        display: 'inline-flex',
        alignItems: 'center'
    },
    chip: {
        marginLeft: getPixelInREM(10)
    },
    or: {
        color: theme.palette.primary.main,
        fontWeight: 600
    },
    textField: {
        width: 350
    },
    iconStyle: {
        color: theme.palette.grey[300]
    },
    verticalDivider: {
        marginLeft: getPixelInREM(10),
        height: 32
    },
    tooltip: {
        fontSize: getPixelInREM(14)
    }
}))
